import { CVEditingSection, FullCV } from '@cibli/shared';
import React from 'react';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface SkillsProps {
  competences: FullCV['competences'];
  onEdit?: (section: CVEditingSection) => void;
  headingColor?: string;
}

const Skills: React.FC<SkillsProps> = ({ competences, onEdit, headingColor }) => {
  const { t } = useCVTranslation();

  const handleEdit = () => {
    if (onEdit) {
      onEdit('competences');
    }
  };

  const editable = onEdit !== undefined;
  if (!competences?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="mb-2 p-2 m-2">
        <h2
          className="text-[11px] font-black uppercase tracking-widest pb-1.5 mb-2.5"
          style={{ color: headingColor ?? '#000000' }}
        >
          {t('CV.skills')}
        </h2>
        <ul className="space-y-1.5">
          {(competences ?? []).map((competence, index) => (
            <li key={index} className="text-[13px] leading-relaxed flex items-start gap-1.5">
              <span className="text-gray-400 mt-0.5">•</span>
              <span>{competence}</span>
            </li>
          ))}
        </ul>
      </div>
    </EditableSection>
  );
};

export default Skills;
